import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http';
import {Config} from "../services/env.config";
import { Router } from '@angular/router';
import { ServerBranch } from 'src/assets/serverBranch';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class AuthService {
  //isLoggedIn: boolean;
  private isAuthenticateds = false; // Initially, the user is not authenticated

  loggedInUser: any;
  redirectUrl: string;
  userToken: string;
  private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
  isAuthenticated$ = this.isAuthenticatedSubject.asObservable();
  constructor(private router: Router,private http: HttpClient) {

  }

  forgotPassword(formData) {
    const req = new HttpRequest('POST', Config.BaseEndpoint + 'user/forgotpassword', formData, {responseType: 'text'});
    return this.http.request(req);
  }

  resetPassword(formData) {
    const req = new HttpRequest('POST', Config.BaseEndpoint + 'user/resetnewpassword', formData, {responseType: 'text'});
    return this.http.request(req);
  }

  changePassword(passwordObject): any {
    let cpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'
      })
    };
    return this.http.put(Config.BaseEndpoint + 'user/changepassword', JSON.stringify(passwordObject), cpHeaders)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);

      });
  }

  isLoggedIn(): boolean {
    
    return this.isAuthenticateds;
  }


  loginData() {
    // Perform login logic
    this.isAuthenticatedSubject.next(true);
  }

  logoutData() {
    // Perform logout logic
    this.isAuthenticatedSubject.next(false);
  }

  isAuthenticated(): boolean {
    return this.isAuthenticatedSubject.value;
  }


  login(logindata): any {
    let loginHeader = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ${userToken}'
      })
    };
    return this.http
      .post(Config.LoginEndpoint, JSON.stringify(logindata), loginHeader)
      .toPromise()
      .then((response: any) => {
        this.isAuthenticateds=true;
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });

  }

  newHeaders = {
    headers: new HttpHeaders({
      'Authorization': 'TokenId',
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'

      
    })
  };

  // loginNew(loginData): any {
  //   return this.http
  //     .post(Config.LoginEndpoint + '/CheckLoginUser' , JSON.stringify(loginData), this.newHeaders)
  //     .toPromise()
  //     .then((response: any) => {
  //       this.isAuthenticateds=true;
  //       return response;
  //     })
  //     .catch((error) => {
  //       return Promise.reject(error);
  //     });
  // }

  loginNew(loginData): any {
    return this.http
      .post(Config.LoginEndpoint + '/CheckLoginUser' , JSON.stringify(loginData), this.newHeaders)
      .toPromise()
      .then((response: any) => {
        this.isAuthenticateds=true;
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  cpHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'

    })
  };


  logout() {
    let sessionData = JSON.parse(sessionStorage.getItem('user')) ;
   
    let user = { UserName : sessionData.UserName }; 
    this.http
    //this.http.post(Config.BaseEndpoint + '/CheckLogoutUser' , JSON.stringify(user), this.cpHeaders)
 
      .post(ServerBranch.BaseEndpoint  + '/CheckLogoutUser', JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response) => {
        // Handle the API response
        
        this.router.navigate(['/login']);
        sessionStorage.clear();
        localStorage.clear();
       
      })
      .catch((error) => {
        // Handle any errors
        console.error(error);
        //this.messageService.errorMessage(error.error_msg, 'error');
      });
  }


  checkAuth() {
    let sessionData = JSON.parse(sessionStorage.getItem('user')) ;
   
    let user = { UserName : sessionData.UserName }; 
    //this.http
    this.http.post(Config.BaseEndpoint + '/CheckAuth' , JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response) => {
        // Handle the API response
       //let desigName = JSON.parse(sessionStorage.getItem('DesigName'));
        
        // Check if designation is "IBD Admin Associate"
        // if(desigName === "IBD Admin Associate") {
        //   this.router.navigate(['/main/cart/payment-checkout']);
        // } else {
        //   this.router.navigate(['/main/home']);
        // }
                  this.router.navigate(['/main/home']);

       
      })
      .catch((error) => {
        if (error.status === 400) {
          
           this.router.navigate(['/login']);
           sessionStorage.clear();
         }

        // Handle any errors
        console.error(error);
        //this.messageService.errorMessage(error.error_msg, 'error');
      });
  }


}
